import { BlotterComponentsAction } from './components/actions';
import { BlotterFilteredOrdersAction } from './filteredOrders/actions';
import { Action } from 'store/store';
import { WidgetActionPayload } from 'widgets/store/actions';
import { WidgetSetConfigAction } from 'widgets/store/configuration/actions';
import { BlotterConfiguration } from 'widgets/blotter/store/configuration/BlotterConfiguration';
import { SetGridColumnWidthAction } from 'widgets/store/grid/columnWidth/actions';
import { BlotterColumn } from 'widgets/blotter/columns/ColumnPortfolio';

export enum BlotterActionType {
    BLOTTER_INITIALISE = 'BLOTTER_INITIALISE',
}

export type BlotterInitialiseAction = Action<
    BlotterActionType.BLOTTER_INITIALISE,
    WidgetActionPayload
>;

export const blotterInitialise: (
    widgetKey: string
) => BlotterInitialiseAction = (widgetKey) => ({
    type: BlotterActionType.BLOTTER_INITIALISE,
    payload: { widgetKey },
});

export type BlotterAction =
    | BlotterInitialiseAction
    | BlotterComponentsAction
    | WidgetSetConfigAction<BlotterConfiguration>
    | SetGridColumnWidthAction<BlotterColumn>
    | BlotterFilteredOrdersAction;
